<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modal.title"
    @on-confirm="saveItem"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
    maxWidth="50%"
  >
    <v-row align="center">
      <v-col cols="12" sm="5">
        <v-text-field
          v-model="dataManagementJob.description"
          :label="$t('Description')"
          :error-messages="descriptionErrors"
          @input="$v.dataManagementJob.description.$touch()"
          @blur="$v.dataManagementJob.description.$touch()"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-select
          v-model="dataManagementJob.type"
          :items="jobTypes"
          :label="$t('Action')"
          item-text="text"
          item-value="id"
          :error-messages="typeErrors"
          @change="$v.dataManagementJob.type.$touch()"
          @blur="$v.dataManagementJob.type.$touch()"
        ></v-select>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-text-field
      readonly
      v-model="dataManagementJob.displayConditionStr"
      :label="$t('Condition')"
      :append-icon="
        dataManagementJob.conditionStr == '' ? 'mdi-plus' : 'mdi-pencil'
      "
      @click:append="editCondition"
    ></v-text-field>

    <SearchCriteriaBuilderModal
      :ref="conditionModalKey"
      :contentTypeIDs="userContentTypes"
      @on-condition-saved="onConditionChanged"
    />

    <v-divider></v-divider>
    <div class="mt-5">
      {{ $t("AffectedDocuments") }}:
      <v-progress-circular
        v-if="loading"
        :size="25"
        color="primary"
        indeterminate
      ></v-progress-circular>
      <span v-if="!loading">{{ affectedDocuments }}</span>
    </div>
  </base-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import SearchCriteriaBuilderModal from "@/components/search/SearchCriteriaBuilderModal.vue";
import DataManagementJobService from "@/services/DataManagementJobService";
import Utils from "@/ecm/common/Utils.js";
import DataManagementJob from "@/ecm/models/DataManagementJob";
import DataManagementJobType from "@/ecm/variables/DataManagementJobType";

export default {
  components: {
    SearchCriteriaBuilderModal,
  },
  props: {
    documentId: {
      type: Number,
      default: 0,
    },
  },
  created() {
    this.$v.$reset();
  },
  data() {
    return {
      modal: {
        title: this.$t("DataManagement"),
        key: "dataManagementJobModal",
      },
      jobTypes: [
        {
          id: DataManagementJobType.ExportWithMetadata,
          text: this.$t("ExportWithMetadata"),
        },
        {
          id: DataManagementJobType.ExportOnlyFiles,
          text: this.$t("ExportOnlyFiles"),
        },
        {
          id: DataManagementJobType.Delete,
          text: this.$t("Delete"),
        },
      ],
      dataManagementJob: new DataManagementJob(),
      loading: false,
      affectedDocuments: 0,
      open: false,
      conditionModalKey: "conditionModalKey",
      searchAllVersions: false,
      isNew: true,
    };
  },
  mixins: [validationMixin],
  validations: {
    dataManagementJob: {
      description: { required },
      type: { required },
    },
  },
  computed: {
    descriptionErrors() {
      const errors = [];
      if (!this.$v.dataManagementJob.description.$dirty) return errors;
      !this.$v.dataManagementJob.description.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
    typeErrors() {
      const errors = [];
      if (!this.$v.dataManagementJob.type.$dirty) return errors;
      !this.$v.dataManagementJob.type.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
    modalInstance() {
      return this.$refs[this.modal.key];
    },
    userContentTypes() {
      return this.$store.getters["account/userContentTypes"].map((x) => x.id);
    },
    conditionModalInstance() {
      return this.$refs[this.conditionModalKey];
    },
  },
  methods: {
    editCondition() {
      this.conditionModalInstance.edit(this.dataManagementJob.conditionStr);
    },
    onConditionChanged(condition) {
      this.dataManagementJob.conditionStr = condition.conditionStr;
      this.dataManagementJob.displayConditionStr =
        condition.displayConditionStr;

      this.UpdateAffectedDocuments();
    },
    UpdateAffectedDocuments() {
      this.loading = true;
      DataManagementJobService.getDocumentCount(
        this.dataManagementJob.conditionStr
      ).then((documentCount) => {
        this.loading = false;
        this.affectedDocuments = documentCount;
      });
    },
    saveItem() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.modalInstance.progress(true);

      DataManagementJobService.save(this.dataManagementJob.toDto())
        .then((result) => {
          if (result) {
            if (this.isNew) {
              Utils.toast.success(
                this.$t("Job") + " " + this.$t("CreatedSuccessfully")
              );
            } else {
              Utils.toast.success(
                this.$t("Job") + " " + this.$t("UpdatedSuccessfully")
              );
            }
            this.hide();
            this.$emit("on-item-saved");
          }
        })
        .catch((error) => {
          // error
        })
        .then(() => {
          //always
          this.modalInstance.progress(false);
        });
    },
    new() {
      this.dataManagementJob = new DataManagementJob();
      this.affectedDocuments = 0;
      this.$v.$reset();
      this.show();
    },
    edit(dto) {
      this.dataManagementJob = new DataManagementJob(dto);
      this.isNew = false;
      this.UpdateAffectedDocuments();
      this.$v.$reset();
      this.show();
    },
    show() {
      this.$v.$reset();
      this.open = true;
    },
    hide() {
      this.open = false;
      this.isNew = true;
    },
  },
};
</script>